import React, { useState, useEffect } from "react";
import "../styles.css";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StarRating from "./UserPatientScreen/StarRating";
import { API_IP } from "../global_variables";

const CareProviderCard = ({ provider, setSelectedSection }) => {
  const [userRating, setUserRating] = useState(0);
  const navigate = useNavigate();
  const imgList = {
    Jonas: 1,
    "Test Provider": 2,
    "Kha Hoang": 3,
    BetterLifeInc: 2,
    WeCare: 1,
    "Dang Provider": 3,
    KhaThi: 1,
  };
  return (
    <button
      onClick={() => {
        navigate(`/CareProviderProfile?id=${provider.provider_id}`, {
          state: {
            data: provider,
            imgIndex: imgList[provider.provider_name],
          },
        });
      }}
      className="careProviderCardLink"
    >
      <div className="care-provider-img-container">
        <img
          src={provider.img_url || require("../images/avatar_placeholder.png")}
          alt={provider.provider_name}
          className="care-provider-img"
        />
      </div>
      <div className="care-provider-info-container">
        <div className="listStyleNone textWeight300 textBold">
          {provider.provider_name}
          <StarRating rating={4} maxStars={5} />
        </div>
        <div className="listStyleNone ProviderTitleText">{provider.title}</div>
        <div className="listStyleNone textWeight300">
          Hours: {provider.opening_hour}:00 - {provider.closing_hour}
          :00
        </div>
      </div>
    </button>
  );
};

const ProviderSelection = ({ setSelectedSection }) => {
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_IP}/api/providers`)
      .then((response) => {
        setProviders(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the providers!", error);
      });
  }, []);

  return (
    <>
      <div className="userHomeContainer">
        <div className="titleContainer">
          <h1>Care Providers</h1>
          <h3>Browse through our catalogue of care providers.</h3>
        </div>

        <div className="careProviderList">
          {providers.map((provider, index) => {
            return (
              <div className="provider-card-container" key={index}>
                <CareProviderCard
                  key={index}
                  provider={provider}
                  setSelectedSection={setSelectedSection}
                />
              </div>
            );

            return null;
          })}
        </div>
      </div>
    </>
  );
};

export default ProviderSelection;
